/**
 * `useEffectiveReviewPolicy` (M3) — resuelve la política de revisión efectiva
 * para una tarea (override de tarea → defaults de org → fallback) local-first,
 * espejo de `effective_review_policy` del write-path. No conoce la corrección
 * única del proyecto final (columna de otra vertical); el servidor la aplica y
 * es quien decide en última instancia — esto sólo gatea la UI.
 */
import { type Accessor, createMemo } from "solid-js";
import { resolvePolicy, type ReviewPolicy } from "@space/shared";
import { useReviewPolicy, useTutoringSettings } from "./hooks";

export function useEffectiveReviewPolicy(
  assignmentId: Accessor<string | undefined>,
  orgId: Accessor<string | undefined>,
): () => ReviewPolicy {
  const settings = useTutoringSettings(orgId);
  const override = useReviewPolicy(assignmentId);
  const policy = createMemo<ReviewPolicy>(() => {
    const s = (settings.data ?? [])[0];
    const o = (override.data ?? [])[0];
    return resolvePolicy(
      s
        ? {
            allowResubmission: (s.allow_resubmission ?? 1) !== 0,
            maxVersions: s.max_versions ?? 3,
            slaDays: s.sla_days ?? 3,
          }
        : null,
      o
        ? {
            allowResubmission: o.allow_resubmission == null ? null : o.allow_resubmission !== 0,
            maxVersions: o.max_versions ?? null,
            slaDays: o.sla_days ?? null,
          }
        : {},
    );
  });
  return policy;
}
